import {h, Component} from 'preact';

import FontFamilyWidget from "./FontFamilyWidget";
import TextSizeWidget from "./TextSizeWidget";
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import util, {roundOneDecimalScaled} from '../util';
import Renderer from "../canvas/renderer";
import constants from "../constants";
import Interactable from "../canvas/interactable";
import TextStyleWidget from "./TextStyleWidget";
import MOTextAlignWidget from './MOTextAlignWidget';

export default @connect(reduce, actions)
class MenuObjectNameNoteStyles extends Component {
  constructor(props) {
    super()

    this.currentColor = () => {
        if (this.props.menuObjectStyles[this.props.type] && this.props.menuObjectStyles[this.props.type]['color']) {
            return this.props.menuObjectStyles[this.props.type]['color'];
        } else {
            return '#fff';
        }
    }
    this.$element = props.$element;
  }

  changeFontFamily(font) {
    this.props.onStyleChange('font-family', font.font);
  }

  adjustPercent(originalSize, scale, percent) {
    const expectedValue = roundOneDecimalScaled(originalSize);
    const actualValue = roundOneDecimalScaled(util.convertInlineSize(percent) * scale);

    if (expectedValue !== actualValue) {
      if (expectedValue > actualValue) {
        return this.adjustPercent(originalSize, scale, percent + 0.01); 
      } else {
        return this.adjustPercent(originalSize, scale, percent - 0.01);
      }
    }

    return percent;
  }

  changeSize(size) {
    size = size.target ? size.target.value : size;

    if (size > 400) {
      size = 400;
    }

    const originalSize = size;
    const scale = Interactable.of(this.$element).getScale();

    size /= scale;

    let percent = 0;
    const dims = Renderer.getDimensions();
    if (dims.unit === 'in') {
      const pixels = util.getPointsInPixels(size, dims);
      percent = util.pixelToPercent(pixels, dims.fontSize);
    } else {
      percent = size * constants.PIXEL_FONT_SIZE_ADJUSTMENT;
    }

    percent = this.adjustPercent(originalSize, scale, percent);

    this.props.onStyleChange('font-size', `${percent}%`);
  }

  textAlign(value) {
    this.props.onStyleChange('text-align', value);

    let float = 'none';
    if (value === 'right') float = 'right';
    this.props.onStyleChange('float', float);

    let margin = '0';
    if (value === 'center') margin = '0 auto';
    else if (value === 'right') margin = '0 0 0 auto';
    this.props.onStyleChange('margin', margin);
  }

  updateColor(value) {
    this.props.onStyleChange('color', value);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.$element = nextProps.$element;
  }

  render(props, state) {
    let styles = props.nameNoteStyles[props.type];
    if (!styles['font-family']) {
      styles = props.menuObjectStyles[props.type];
    }

    const fontSize = util.convertInlineSize(styles['font-size'] || 100);

    const color = styles['color'] || constants.DEFAULT_TEXT_COLOR;

    const font = util.getFontByFamily(styles['font-family']);
    const fontKey = font ? font.key : '';
    const fontFamily = font ? font.label : '';

    const id = props.$element.attr('id');

    return (
      <div className="mos names-notes">
        <div class="styles-label">
          <h5>{props.label}</h5>
          {props.applyToAllDD ? props.applyToAllDD : <div></div>}
        </div>
        <ul key={id}>
          <li className="font-wrap">
            <FontFamilyWidget fontKey={fontKey} family={fontFamily} changeFont={this.changeFontFamily.bind(this)}/>
          </li>
          <li className="size-wrap">
            <TextSizeWidget key={`mo-size-${props.label}`} $element={props.$element} value={fontSize} onChange={this.changeSize.bind(this)}/>
          </li>

          <li className="text-wrap">
            <TextStyleWidget $element={props.$element} menuObjectStyles={props.menuObjectStyles} type={props.type} onStyleChange={props.onStyleChange} />
          </li>

          <li className="align-wrap">
            <MOTextAlignWidget $element={props.$element} menuObjectStyles={props.menuObjectStyles} type={props.type} onStyleChange={props.onStyleChange} />
          </li>

          <li className="saf-stop color-wrap">
              <a onClick={() => this.props.openColorPicker(constants.pickerTypes.moFont)}>
                <span className="color-box" style={`background: ${this.currentColor()}; float: none;`}></span>
              </a>
          </li>
        </ul>
      </div>
    )
  }
}
